<template>
    <div>
        <div class="col-lg-12">
            <form class="needs-validation" autocomplete="off">
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.temporarily.nameTemp') }}</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-template`"
                            :value.sync="basicForm.template"
                            :options="templatePage"
                            :config="configForm.configFieldSelectTemplate"
                            @open="handleOpenSelectTemplate"
                            @select="handleSelectTemplate"
                            @remove="handleRemoveSelectTemplate"
                        />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.nameCampaign') }}</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-campaign-for-form-page`"
                            :value.sync="basicForm.campaign"
                            :options="listDataMasterCampaign"
                            :config.sync="configForm.configFieldSelectCampaign"
                            @select="handleSelectCampaign('select')"
                            @remove="handleRemoveSelectCampaign"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.nameClient') }}</label>
                    <div class="col-sm-9">
                        <Multiselect
                            :id="`select-client-for-form-page`"
                            :value.sync="basicForm.client"
                            :options="listClientsCP"
                            :config.sync="configForm.configFieldSelectClient"
                            @open="handleSelectCampaign('mounted')"
                            @remove="handleValidateField(configForm.configFieldSelectClient)"
                        />
                    </div>
                </div>

                <!-- フォーム名 -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                        >{{ $t('managerForm.settingBasic.nameForm') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <InputText
                            :model.sync="basicForm.name"
                            :config.sync="configForm.configFieldNameForm"
                            @blur="handleValidateField(configForm.configFieldNameForm)"
                        />
                    </div>
                </div>
                <!-- chọn kiểu  -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                        >{{ $t('managerForm.settingPage.pageType') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col-sm-3">
                                <Multiselect
                                    :id="`select-page`"
                                    :value.sync="basicForm.page_type"
                                    :options="pageList"
                                    :config="configForm.configFieldSelectPage"
                                    :disabled="isQueryId"
                                    @select="handleSelectPage"
                                    @remove="handleValidateField(configForm.configFieldSelectPage)"
                                />
                            </div>
                            <div>
                                <button type="button" class="btn btn-info" @click="() => (configModalListWorkflow.model = true)">
                                    <i class="fa fa-info" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ステータス -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.status') }} </label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <div v-for="statusItem in STATUS_FORM" :key="statusItem.id + 's'">
                                <InputRadio
                                    class="mr-4 mb-3"
                                    :model.sync="basicForm.status"
                                    :name="`statusItem`"
                                    :id="`statusItem-${statusItem.id}`"
                                    :value="statusItem.id"
                                    :label="statusItem.value"
                                />
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- 開始スケジュール -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                        >{{ $t('managerForm.settingBasic.scheduleStart') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <div v-for="item in OPTION_PUBLIC_START_FORM" :key="item.id + 'date_now'">
                                <InputRadio
                                    class="mr-4 mb-3"
                                    :model.sync="basicForm.is_publish_start_date_now"
                                    :name="`is-publish-start`"
                                    :id="`is-publish-start-${item.id}`"
                                    :value="item.id"
                                    :label="item.name"
                                    @change="onHandleChangeIsPublishStartDateNow"
                                />
                            </div>
                        </div>
                        <DateTime
                            id="select-publication-starts-date-time"
                            :full_date.sync="basicForm.publish_start_date"
                            :full_time.sync="basicForm.publish_start_time"
                            :config.sync="configForm.configFieldPublicationStartDateTime"
                            :disabled="basicForm.is_publish_start_date_now === OPTION_PUBLIC_START_FORM[0].id"
                            @blur="
                                handleValidateField(
                                    configForm.configFieldPublicationStartDateTime,
                                    ['compare-date'],
                                    ['configFieldPublicationStartDateTime', 'configFieldPublicationEndDateTime']
                                )
                            "
                        >
                            <span v-if="configForm.configFieldPublicationStartDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldPublicationStartDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div> -->
                <!-- 終了スケジュール	 -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                        >{{ $t('managerForm.settingBasic.scheduleEnd') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <div v-for="item in OPTION_PUBLIC_END_FORM" :key="item.id + 'end_date'">
                                <InputRadio
                                    class="mr-4 mb-3"
                                    :model.sync="basicForm.publish_has_no_end_date"
                                    :name="`has_no_end`"
                                    :id="`has_no_end-${item.id}`"
                                    :value="item.id"
                                    :label="item.name"
                                    @change="onHandleChangeIsPublishEndDateNow"
                                />
                            </div>
                        </div>
                        <DateTime
                            id="select-publication-end-date-time"
                            :full_date.sync="basicForm.publish_end_date"
                            :full_time.sync="basicForm.publish_end_time"
                            :config.sync="configForm.configFieldPublicationEndDateTime"
                            :disabled="basicForm.publish_has_no_end_date === OPTION_PUBLIC_START_FORM[0].id"
                            @blur="
                                handleValidateField(
                                    configForm.configFieldPublicationEndDateTime,
                                    ['compare-date'],
                                    ['configFieldPublicationStartDateTime', 'configFieldPublicationEndDateTime']
                                )
                            "
                        >
                            <span v-if="configForm.configFieldPublicationEndDateTime.error" class="invalid-feedback d-block">{{
                                configForm.configFieldPublicationEndDateTime.errorText
                            }}</span>
                        </DateTime>
                    </div>
                </div> -->
                <!-- 公開パス -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                        >{{ $t('managerForm.settingBasic.publicPath') }} <span class="text-danger">*</span></label
                    >
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap align-items-center">
                            <Multiselect
                                v-if="listCustomDomains.length > 0"
                                class="mr-2 mt-3"
                                style="max-width: 250px"
                                :options="listCustomDomains"
                                :value.sync="selectedCustomDomain"
                                :config="{
                                    label: 'domain',
                                    trackBy: 'id',
                                    placeholder: '',
                                    searchable: true,
                                    error: false,
                                    isRemove: false
                                }"
                            />
                            <span class="mr-1 mt-3" style="line-height: 0.5">/form/</span>
                            <InputText
                                class="mt-3"
                                :model.sync="basicForm.url_public"
                                :config.sync="configForm.configFieldPublicPath"
                                @blur="handleValidateField(configForm.configFieldPublicPath)"
                            />
                        </div>
                        <span class="" style="font-size: 12px">{{ $t('managerForm.settingBasic.noteUrlPublic') }}</span>
                    </div>
                </div>

                <!-- 公開予約中表示URL -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.urlPublicReservation') }}</label>
                    <div class="col-sm-9">
                        <InputText
                            :model.sync="basicForm.reservation_display_url"
                            :config.sync="configForm.configFieldUrlPublicReservation"
                            @blur="handleValidateField(configForm.configFieldUrlPublicReservation)"
                        />
                    </div>
                </div> -->
                <!-- 公開終了後表示URL -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.urlAfterPublicationEnd') }} </label>
                    <div class="col-sm-9">
                        <InputText
                            :model.sync="basicForm.expired_display_url"
                            :config.sync="configForm.configFieldUrlAfterPublicationEnd"
                            @blur="handleValidateField(configForm.configFieldUrlAfterPublicationEnd)"
                        />
                    </div>
                </div> -->
                <!-- 送信先メールアドレス -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.sendMailed') }}</label>
                    <div class="col-sm-9">
                        <InputText
                            :model.sync="basicForm.mail_to"
                            :config.sync="configForm.configFieldSendMailed"
                            @blur="handleValidateField(configForm.configFieldSendMailed)"
                        />
                    </div>
                </div> -->
                <!-- フォームの一時保存 -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.saveTemp') }} </label>
                    <div class="col-sm-9">
                        <div class="d-flex flex-wrap">
                            <div v-for="item in TEMPORARILY" :key="item.id + 's'">
                                <InputRadio
                                    class="mr-4 mb-3"
                                    :model.sync="basicForm.save_form_temporarily"
                                    :name="`save-temp`"
                                    :id="`save-temp-${item.id}`"
                                    :value="item.id"
                                    :label="item.value"
                                />
                            </div>
                            <div class="form-group row flex-fill">
                                <label class="col-sm-1 text-nowrap" style="min-width: fit-content"
                                    >{{ $t('managerForm.settingBasic.dateOfExpiry') }}
                                </label>
                                <div class="col-sm-8">
                                    <InputText
                                        style="min-width: 100px"
                                        :model.sync="basicForm.temporary_expiration_date"
                                        :config.sync="configForm.configFieldDateOfExpiry"
                                        @blur="handleValidateField(configForm.configFieldDateOfExpiry)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- ソーシャルログイン設置 -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 180px">{{ $t('managerForm.settingBasic.settingLoginSocial') }} </label>
                    <div class="col-sm-9">
                        <div v-for="(social, index) in SOCIAL_MEDIA_LOGIN" :key="index" class="form-group row">
                            <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ social?.name ?? '' }} </label>
                            <div class="col-sm-9">
                                <InputText
                                    :model.sync="social.value"
                                    :config.sync="configForm.validateArraySocial[index].configField"
                                    @blur="handleValidateField(configForm.validateArraySocial[index].configField)"
                                />
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- マイページ機能設置 -->
                <!-- <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.settingMypage') }} </label>
                    <div class="col-sm-9">
                        <InputRadio :model.sync="basicForm.setting_my_page" :id="`setting_my_page`" :value="true" :label="``" />
                    </div>
                </div> -->
                <!-- TAG -->
                <div class="form-group row">
                    <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.tag') }}</label>
                    <div class="col-sm-9">
                        <KeyWordTag2
                            :id="`tag-keywords`"
                            :model.sync="basicForm.hashtag"
                            :config.sync="configForm.configFieldTag"
                            @blur="handleValidateField(configForm.configFieldTag)"
                        >
                            <span v-if="configForm.configFieldTag.error">
                                {{ configForm.configFieldTag.errorCustomMess }}
                            </span>
                        </KeyWordTag2>
                    </div>
                </div>
                <template v-if="![ID_PAGE_TYPE.C].includes(basicForm.page_type?.id)">
                    <hr />
                    <div class="row pt-3">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">
                            <h5 class="mb-4">オプション</h5>
                        </label>
                    </div>
                    <!-- URLパラメータ -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.urlParam') }}</label>
                        <div class="col-sm-9">
                            <button
                                v-if="basicForm.url_parameters.length === 0"
                                type="button"
                                class="btn btn-outline-info btn-sm rounded-circle mb-3"
                                @click="handleAddURL()"
                            >
                                <i class="fa fa-plus"></i>
                            </button>
                            <div v-for="(urlP, index) in basicForm.url_parameters" :key="index" class="mb-3">
                                <div class="d-flex mb-3" style="gap: 12px">
                                    <InputText
                                        v-if="configForm.validateArrayURL[index]?.configFieldUrlKey"
                                        class="flex-fill"
                                        style="min-width: 150px"
                                        :id="`${index}-key`"
                                        :model.sync="urlP.params"
                                        :config.sync="configForm.validateArrayURL[index].configFieldUrlKey"
                                        @blur="handleValidateField(configForm.validateArrayURL[index].configFieldUrlKey)"
                                    />
                                    <InputText
                                        v-if="configForm.validateArrayURL[index]?.configFieldUrlValue"
                                        class="flex-fill"
                                        style="min-width: 150px"
                                        :id="`${index}-value`"
                                        :model.sync="urlP.note"
                                        :config.sync="configForm.validateArrayURL[index].configFieldUrlValue"
                                        @blur="handleValidateField(configForm.validateArrayURL[index].configFieldUrlValue)"
                                    />
                                    <div class="col-sm-2">
                                        <div class="d-flex" style="gap: 12px">
                                            <button type="button" class="btn btn-outline-info btn-sm rounded-circle" @click="handleAddURL()">
                                                <i class="fa fa-plus"></i>
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-outline-danger btn-sm rounded-circle"
                                                @click="handleDeleteURL(index)"
                                            >
                                                <i class="fa fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="" style="font-size: 12px">※文字、数字、アルファベット、特殊文字を含む255文字以内で入力してください。</div>
                        </div>
                    </div>
                    <!-- 指定応募数 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 150px"
                            >{{ $t('managerForm.settingBasic.limitPersonApplication') }}
                        </label>
                        <div class="col-sm-9">
                            <!-- 制限件数 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{ $t('managerForm.settingBasic.limitNumber') }} </label>
                                <div class="col-sm-9">
                                    <div class="d-flex">
                                        <InputText
                                            class="mr-2"
                                            :model.sync="basicForm.application_limit"
                                            :config.sync="configForm.configFieldLimitNumber"
                                            @blur="handleValidateField(configForm.configFieldLimitNumber)"
                                        />
                                        <span class="mt-2">件</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 超過時リダイレクトURL -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 180px">{{ $t('managerForm.settingBasic.redirectURL') }} </label>
                                <div class="col-sm-9">
                                    <InputText
                                        :model.sync="basicForm.url_redirect_when_limit"
                                        :config.sync="configForm.configFieldRedirectURL"
                                        @blur="handleValidateField(configForm.configFieldRedirectURL)"
                                    />
                                </div>
                            </div>
                            <!-- 期間前 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                    $t('managerForm.settingBasic.beforeThePeriod')
                                }}</label>
                                <div class="col-sm-9">
                                    <InputText
                                        :model.sync="basicForm.before_the_period_url"
                                        :config.sync="configForm.configFieldBeforeThePeriod"
                                        @blur="handleValidateField(configForm.configFieldBeforeThePeriod)"
                                    />
                                </div>
                            </div>
                            <!-- 期間後 -->
                            <div class="form-group row">
                                <label class="col-sm-3 text-nowrap" style="min-width: 150px">{{
                                    $t('managerForm.settingBasic.afterThePeriod')
                                }}</label>
                                <div class="col-sm-9">
                                    <InputText
                                        :model.sync="basicForm.after_the_period_url"
                                        :config.sync="configForm.configFieldAfterThePeriod"
                                        @blur="handleValidateField(configForm.configFieldAfterThePeriod)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="basicForm.page_type?.id === ID_PAGE_TYPE.I">
                    <!-- 空メール有効期限 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.blankEmailExpirationDate') }}
                        </label>
                        <div class="col-sm-9">
                            <div class="form-group row">
                                <!-- 送信後 -->
                                <label class="col-sm-1 text-nowrap" style="min-width: 100px"
                                    >{{ $t('managerForm.settingBasic.afterSending') }}
                                </label>
                                <div class="col-sm-9">
                                    <div class="d-flex">
                                        <InputText
                                            class="mr-2"
                                            :model.sync="basicForm.link_expiration_time"
                                            :config.sync="configForm.configFieldBlankEmailExpirationDate"
                                            @blur="handleValidateField(configForm.configFieldBlankEmailExpirationDate)"
                                        />
                                        <span class="mt-2">{{ $t('text.minutes') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 重複登録 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.duplicateRegistration') }}
                        </label>
                        <div class="col-sm-9">
                            <InputCheckBox
                                :model.sync="basicForm.allow_duplicate_email"
                                :id="`check-Allow_duplicate_email`"
                                :value="basicForm.allow_duplicate_email"
                                :label="$t('managerForm.settingBasic.noteDuplicateRegistration')"
                            />
                        </div>
                    </div>
                    <!-- 登録済みURLのエラー画面 -->
                    <div class="form-group row">
                        <label class="col-sm-3 text-nowrap" style="min-width: 180px"
                            >{{ $t('managerForm.settingBasic.settingNotRegisterAgain') }}
                        </label>
                        <div class="col-sm-9">
                            <!-- <TextareaComponent :model.sync="basicForm.setting_not_register_again" :rows="`5`" /> -->
                            <Editor
                                :id="`editor-register_email_text`"
                                :model.sync="basicForm.setting_not_register_again"
                                :configInit="{
                                    height: 300,
                                    error: false
                                }"
                            />
                        </div>
                    </div>
                </template>
                <template v-if="basicForm.page_type?.id === ID_PAGE_TYPE.B">
                    <SettingSerialCodeLottery
                        :dataForm.sync="basicForm.setting_lottery"
                        :dataPrizes.sync="basicForm.serial_code_prizes"
                        :dataSerialCode="basicForm.setting_serial_code"
                        :configValid="configValidFormLottery"
                    />
                </template>
            </form>
            <ModalCommon :id="`ModalListWorkflow`" :config="configModalListWorkflow" @close="onHandleClose" :isView="true">
                <img style="width: 100%; height: 100%; object-fit: contain" src="/images/form/workflow/list_wl.png" alt="" />
            </ModalCommon>
        </div>
    </div>
</template>

<script>
import { InputText, InputCheckBox } from '@/components/Input';
// import TextareaComponent from '@/components/Textarea/main.vue';
import Editor from '@/components/Editor/main.vue';

import { validateField } from '@/utils/validate';
import {
    TEMPORARILY,
    SOCIAL_MEDIA_LOGIN,
    STATUS_FORM,
    OPTION_PUBLIC_START_FORM,
    OPTION_PUBLIC_END_FORM,
    initSettingPage,
    initFormPage,
    initSettingDesgin,
    ID_PAGE_TYPE
} from '../../constants';
import { masterMethods, campaignMethods, managerFormMethods } from '@/state/helpers';
import { handleAddConfigURL, configModalListWorkflow } from './constants';
import { cloneDeep } from 'lodash';
import { handleMapDataCPIntoForm, validateEndDate, handleMapBlockRes, handleMapSettingDesign, onCheckDisableTemplate } from '../../handlers';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import { getInfoUserLocalStorage } from '@/utils/handlers';

import Multiselect from '@/components/Multiselect/main.vue';
// import DateTime from '@/components/DateCustoms/DateTime/main.vue';

import KeyWordTag2 from '@/components/KeywordTag/main2.vue';
import ModalCommon from '@/components/Modal/main.vue';
import SettingSerialCodeLottery from '@/views/pages/phase2/manager-form/components/setting-lottery/main.vue';

export default {
    name: 'SettingBasic',
    components: {
        InputText,
        // InputRadio,
        Multiselect,
        // DateTime
        KeyWordTag2,
        ModalCommon,
        InputCheckBox,
        Editor,
        SettingSerialCodeLottery
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configForm: {
            type: Object,
            required: true,
            default: () => null
        },
        configValidFormLottery: {
            type: Object,
            required: true,
            default: () => null
        },
        listPage: {
            type: Array,
            default: () => []
        },
        templatePage: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            TEMPORARILY: TEMPORARILY,
            STATUS_FORM: STATUS_FORM,
            OPTION_PUBLIC_START_FORM: OPTION_PUBLIC_START_FORM,
            OPTION_PUBLIC_END_FORM: OPTION_PUBLIC_END_FORM,
            basicForm: cloneDeep(this.dataForm),
            SOCIAL_MEDIA_LOGIN: this.dataForm?.setting_login_social?.length > 0 ? this.dataForm.setting_login_social : SOCIAL_MEDIA_LOGIN,
            listDataMasterCampaign: [],
            listClientsCP: [],
            listTemp: this.templatePage,
            domainForm: `${process.env.VUE_APP_DOMAIN_FORM}/form/`,
            configModalListWorkflow,
            ID_PAGE_TYPE,
            pageList: this.listPage,
            listCustomDomains: [],
            selectedCustomDomain: null
        };
    },
    computed: {
        isQueryId() {
            return this.$route.query?.id ? true : false;
        }
    },
    methods: {
        ...masterMethods,
        ...campaignMethods,
        ...managerFormMethods,

        async handleSelectCampaign(type = 'select') {
            if (!this.basicForm.campaign?.id) return;
            if (type === 'select') {
                this.basicForm.client = null;
                this.listClientsCP = [];
            }
            try {
                const dataResCampaign = await this.getDetailDocuments(this.basicForm.campaign);
                const clientList = dataResCampaign.data?.clients.map((clientItem) => clientItem.client) ?? [];
                const uniqueClients = clientList.filter((client, index, self) => index === self.findIndex((c) => c.id === client.id));
                this.listClientsCP = uniqueClients;
                handleMapDataCPIntoForm(this.basicForm, dataResCampaign.data);
            } catch (error) {
                console.log('error', error);
            }
        },

        handleRemoveSelectCampaign() {
            this.basicForm.client = null;
            this.listClientsCP = [];
            // this.handleValidateField(configFieldSelectCampaign);
        },

        handleValidateField(configField, action = [], configValidate = []) {
            validateField(configField);
            if (action.includes('compare-date')) {
                validateEndDate(this.configForm[configValidate[0]], this.configForm[configValidate[1]]);
            }
        },

        handleAddURL() {
            this.basicForm.url_parameters.push({ params: '', note: '' });
            this.configForm.validateArrayURL = handleAddConfigURL(this.configForm.validateArrayURL, this.basicForm.url_parameters);
        },

        handleDeleteURL(index) {
            this.basicForm.url_parameters.splice(index, 1);
            this.configForm.validateArrayURL = handleAddConfigURL(this.configForm.validateArrayURL, this.basicForm.url_parameters);
        },

        async getMasterCampaign() {
            this.isLoading = true;
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataMasterCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        onHandleChangeIsPublishStartDateNow(value) {
            this.configForm.configFieldPublicationStartDateTime.error = false;
            if (value === OPTION_PUBLIC_START_FORM[0].id) {
                this.configForm.configFieldPublicationStartDateTime.typesValidate =
                    this.configForm.configFieldPublicationStartDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configForm.configFieldPublicationStartDateTime.typesValidate.push('requiredDate');
            }
        },

        onHandleChangeIsPublishEndDateNow(value) {
            this.configForm.configFieldPublicationEndDateTime.error = false;
            if (value === OPTION_PUBLIC_END_FORM[0].id) {
                this.configForm.configFieldPublicationEndDateTime.typesValidate =
                    this.configForm.configFieldPublicationEndDateTime.typesValidate.filter((item) => item !== 'requiredDate');
            } else {
                this.configForm.configFieldPublicationEndDateTime.typesValidate.push('requiredDate');
            }
        },

        handleOpenSelectTemplate() {
            this.$emit('handleOpenSelectTemplate');
        },

        async handleSelectTemplate(temp) {
            this.handleValidateField(this.configForm.configFieldSelectTemplate);
            if (!temp?.id) return;
            try {
                const dataDetailTemp = await this.getDetailTemplateManagerForm(temp.id);
                let dataTemp = dataDetailTemp.data;
                let design2 = dataTemp?.setting_designs?.design_2 ?? null;
                this.basicForm.form_pages.page_inputs = dataTemp?.form_pages?.page_inputs;
                this.basicForm.form_pages.page_confirms = dataTemp?.form_pages?.page_confirms;
                this.basicForm.header = design2?.header ?? '';
                this.basicForm.footer = design2?.footer ?? '';
                this.basicForm.google_analytics = design2?.google_analytics ?? '';
                this.basicForm.description = design2?.description ?? '';
                this.basicForm.setting_designs = handleMapSettingDesign(dataTemp);
                handleMapBlockRes(this.basicForm, dataTemp, 'create');
                this.pageList = this.pageList.map((item) => {
                    item.$isDisabled = onCheckDisableTemplate(Number(temp?.type), item.id);
                    return item;
                });
            } catch (error) {
                console.log('error', error);
            }
        },
        handleRemoveSelectTemplate() {
            this.handleValidateField(this.configForm.configFieldSelectTemplate);
            this.basicForm.setting_page = this.onHandleResetTemplate();
            this.basicForm.form_pages = {
                ...initFormPage(),
                page_inputs: {
                    ...initFormPage().page_inputs,
                    setting_buttons: {
                        label_btn_register: this.$t('managerForm.settingPage.btnSaveForm'),
                        img_btn_register: null
                    }
                },
                page_confirms: ![ID_PAGE_TYPE.C].includes(this.basicForm.page_type?.id)
                    ? {
                          ...initFormPage().page_confirms,
                          setting_buttons: {
                              label_btn_confirm: '登録',
                              label_btn_back: '戻る',
                              img_btn_confirm: null,
                              img_btn_back: null
                          }
                      }
                    : null
            };
            this.basicForm.setting_designs = initSettingDesgin();
            this.basicForm.header = '';
            this.basicForm.footer = '';
            this.basicForm.google_analytics = '';
            this.basicForm.description = '';
            this.pageList = this.pageList.map((item) => {
                item.$isDisabled = false;
                return item;
            });
        },
        onHandleResetTemplate() {
            const pageTypeId = this.basicForm.page_type?.id || ID_PAGE_TYPE.A;
            if (pageTypeId === ID_PAGE_TYPE.I) {
                let dataPage = initSettingPage(ID_PAGE_TYPE.I);
                dataPage.pages[0].page_child = this.basicForm.setting_page?.pages?.[0]?.page_child || [];
                return dataPage;
            }
            return initSettingPage(pageTypeId);
        },

        onHandleClose() {
            this.configModalListWorkflow.model = false;
        },

        handleSelectPage(page) {
            this.basicForm.setting_page = initSettingPage(page.id);
            this.$emit('selectPage', page);
        },
        async onGetListCustomDomain() {
            try {
                const response = await this.getListCustomDomain('limit=1000');
                let defaultDomainStr = process.env.VUE_APP_DOMAIN_FORM || '';
                defaultDomainStr = defaultDomainStr.replace(/^https?:\/\//, '');
                let defaultDomain = {
                    id: null,
                    domain: defaultDomainStr
                };
                let customDomains = [];
                if (response?.data) {
                    customDomains = response.data;
                }

                this.listCustomDomains = [defaultDomain, ...customDomains];

                if (this.basicForm.custom_domain_id) {
                    this.selectedCustomDomain =
                        this.listCustomDomains.find((item) => item.id === this.basicForm.custom_domain_id) ||
                        (this.basicForm.custom_domain?.id === this.basicForm.custom_domain_id ? this.basicForm.custom_domain : defaultDomain);
                } else {
                    this.selectedCustomDomain = defaultDomain;
                }
            } catch (error) {
                console.log(error);
            }
        }
    },

    watch: {
        dataForm: {
            handler(newVal) {
                this.basicForm = newVal;
                if (!this.basicForm.form_pages.page_inputs && !this.basicForm.form_pages.page_confirms && !this.basicForm.form_pages.page_completes) {
                    this.handleSelectTemplate(this.basicForm.template);
                }
                // this.onHandleChangeIsPublishStartDateNow(newVal.is_publish_start_date_now);
                // this.onHandleChangeIsPublishEndDateNow(newVal.publish_has_no_end_date);
            },
            immediate: true,
            deep: true
        },

        templatePage: {
            handler(newVal) {
                this.listTemp = newVal;
            },
            immediate: true
        },

        basicForm: {
            handler(newBasicForm) {
                this.$emit('update:dataForm', newBasicForm);
                if (this.listCustomDomains.length > 0) {
                    if (newBasicForm.custom_domain_id) {
                        if (!this.selectedCustomDomain || this.selectedCustomDomain.id !== newBasicForm.custom_domain_id) {
                            this.selectedCustomDomain =
                                this.listCustomDomains.find((item) => item.id === newBasicForm.custom_domain_id) ||
                                (this.basicForm.custom_domain?.id === newBasicForm.custom_domain_id ? this.basicForm.custom_domain : null);
                        }
                    } else {
                        if (!this.selectedCustomDomain || this.selectedCustomDomain.id !== null) {
                            this.selectedCustomDomain = this.listCustomDomains.find((item) => item.id === null) || null;
                        }
                    }
                }
            },
            deep: true
        },
        selectedCustomDomain(newVal) {
            this.basicForm.custom_domain_id = newVal ? newVal.id : null;
        }
    },
    mounted() {
        this.configForm.validateArrayURL = handleAddConfigURL(this.configForm.validateArrayURL, this.basicForm.url_parameters);
        this.getMasterCampaign();
        this.onGetListCustomDomain();
        if (this.$route.name === 'ManagerFormCreate' || !this.basicForm.campaign || this.basicForm.page_type?.id === ID_PAGE_TYPE.B)
            this.handleSelectCampaign('mounted');
    }
};
</script>

<style lang="scss" scoped></style>
